import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";

import { CaseQAReview } from "pwapi";

import "./QAReviewInformation.css";

const QAReviewInformation = ({
  qaReview,
  displayIcon,
}: {
  qaReview: CaseQAReview;
  displayIcon?: boolean;
}) => {
  return (
    <div className="QAInformation">
      {qaReview?.id && (
        <>
          {displayIcon && (
            <FontAwesomeIcon
              icon={qaReview.reviewed ? "circle-check" : "circle-xmark"}
              color={qaReview.reviewed ? "var(--green)" : "var(--red)"}
              fontSize={20}
            />
          )}
          <span>
            {qaReview.reviewed ? "Reviewed by" : "Case Held by"}{" "}
            {qaReview.user?.first_name} {qaReview.user?.last_name}
            <br />
            <div className="QAInformation">
              {qaReview.created_at &&
                DateTime.fromISO(qaReview.created_at).toLocaleString(
                  DateTime.DATETIME_SHORT
                )}
              {qaReview.note && (
                <FontAwesomeIcon icon="sticky-note" color="var(--steel)" />
              )}
            </div>
          </span>
        </>
      )}
    </div>
  );
};

export default QAReviewInformation;
